<template>
  <div class="rulekh-wrapper">
    <div class="form-item-blue">
      <van-divider :style="{ color: '#333', padding: '0 16px' }">使用规则</van-divider>
    </div>
    <div class="rule-content">
      <div class="rule-item">
        <div class="title">优惠券领取方法</div>
        <div class="desc">1.活动期间，新用户在上方文本框内输入手机号，获取验证码完成注册，即可领取“可好”超市满20减10优惠券，领取成功后下载登录便捷青岛APP，在“卡券包”中查看使用。</div>
        <div class="desc">2.已注册便捷青岛APP用户，可登录便捷青岛APP首页—领券中心领取更多“可好超市”满减优惠。</div>
      </div>
      <div class="rule-item">
        <div class="title">优惠券使用方法</div>
        <div class="desc">1.所有优惠券领取后可在便捷青岛APP卡券包中查看。</div>
        <div class="desc">2.需开通便捷青岛首页银联付款码功能，在可好店内使用付款码支付，即可完成优惠券核销抵扣。</div>
        <div class="desc">3.每次消费仅可使用1张优惠券，优惠券不兑现，不找零，不开具发票，数量有限，发完为止。</div>
        <div class="desc">（本次活动时间为11月1日—12月31日，活动最终解释权归便捷青岛所有）</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Divider } from 'vant'

export default {
  components: {
    [Divider.name]: Divider
  }
}

</script>
<style lang='scss' scoped>
.rulekh-wrapper {
  margin-top: 20px;
  padding: 0 20px 15px;
  border-radius: 10px;
}
.form-item-blue {
  height: 30px;
  line-height: 30px;
  padding: 0 60px;
  margin-bottom: 10px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  /deep/ .van-divider {
    border-color: #333;
    line-height: 30px;
  }
}
.rule-content {
  padding: 0;
  border-radius: 10px;
}
.rule-item {
  .title {
    font-size: 14px;
    margin: 15px 0 6px;
    color: #282828;
  }
  .desc {
    line-height: 1.6;
    font-size: 12px;
    color: #999;
  }
}

</style>
